import { createSlice } from '@reduxjs/toolkit';
import { fetchPlaceholders } from 'reduxStore/placeholders/asyncActions';
import { addAsyncCasesNew } from 'shared/utils/redux';

import { PlaceholdersState, STORE_NAME } from './initialState';

export const placeholderSlice = createSlice({
  name: STORE_NAME,
  initialState: PlaceholdersState.INITIAL_DOMAIN,
  reducers: {
    clearPlaceholders: (state) => {
      state.listResource = PlaceholdersState.INITIAL_DOMAIN.listResource;
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchPlaceholders, (state, action) => {
      state.listResource = action.payload;
    });
  },
});

export const { clearPlaceholders } = placeholderSlice.actions;
